import ApiService from "../ApiService";

const OrderResendService = {
    resendOrder(orderId) {
        return ApiService.put(`/resend-orders/order/${orderId}`);
    },

    resendOrders(data) {
    return ApiService.post("/resend-orders/orders", data);
    },

    getLog() {
    return ApiService.get("/resend-orders/Log");
    }
 };
 export default OrderResendService;
 